import { render, staticRenderFns } from "./RaceImgCard.vue?vue&type=template&id=39bb8624&scoped=true&"
import script from "./RaceImgCard.vue?vue&type=script&lang=js&"
export * from "./RaceImgCard.vue?vue&type=script&lang=js&"
import style0 from "./RaceImgCard.vue?vue&type=style&index=0&id=39bb8624&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bb8624",
  null
  
)

export default component.exports